import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Wysiwyg',
  props: {
        modelValue: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
  emits: ['update:modelValue', 'save'],
  setup(__props, { emit: __emit }) {

    const props = __props

    const value = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val)
    })

    const emit = __emit

    function addNote(){
        emit('save')
    }

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_editor = _resolveComponent("q-editor")!

  return (_openBlock(), _createBlock(_component_q_editor, {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
    dense: _ctx.$q.screen.lt.md,
    placeholder: __props.placeholder,
    "min-height": "20px",
    "content-class": "tw-text-sm",
    "toolbar-bg": "tw-bg-slate-50",
    toolbar: [
        
        ['bold', 'italic', 'underline', 'unordered', 'ordered'],
        ['addNote']
        ]
  }, {
    addNote: _withCtx(() => [
      _createVNode(_component_q_btn, {
        outline: "",
        style: {"color":"#CBD5E1","background-color":"white !important"},
        loading: __props.loading,
        disabled: __props.loading,
        "no-caps": "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addNote()))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "tw-text-brand-700" }, "Add Note", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue", "dense", "placeholder"]))
}
}

})